import { apiSlice } from "@/shared/api"

interface DetectGroupTimezoneRequest {
  chatId: number
  timezone: string
}

interface DetectGroupTimezoneResponse {
  applied: boolean
  timezone: string
  source: "device" | "admin" | "import" | null
  reason?: "non_geographic" | null
}

export const detectGroupTimezoneApi = apiSlice.enhanceEndpoints({ addTagTypes: ["GroupSettings"] }).injectEndpoints({
  endpoints: builder => ({
    detectGroupTimezone: builder.mutation<DetectGroupTimezoneResponse, DetectGroupTimezoneRequest>({
      query: ({ chatId, timezone }) => ({
        url: `/api/v1/group/settings/timezone/detect?chat_id=${chatId}`,
        method: "POST",
        body: { timezone }
      }),
      invalidatesTags: (result, error, { chatId }) =>
        !error && result ? [{ type: "GroupSettings" as const, id: `CHAT_${chatId}` }] : []
    })
  })
})

export const { useDetectGroupTimezoneMutation } = detectGroupTimezoneApi
